<template lang="pug">
    .bookmark

        svg.bookmark__icon(
            width='24',
            height='35',
            viewBox='0 0 24 35',
            xmlns='http://www.w3.org/2000/svg',
            @click='setBookmark',
            :class='{active: isBookmarkActive}',
            v-show='$route.name === "article"'
            )
            path(
                d='M22 32L12 27.2L2 32V2H22V32Z',
                stroke-width='3',
                stroke-miterlimit='10'
                )


</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'Bookmark',

    components: {},

    computed: mapState(['isBookmarkActive', 'bookmark']),

    methods: {
        setBookmark() {
            this.$store.dispatch('setBookmark', {params: this.$route.params, scrollPos: window.scrollY});
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';

.bookmark {
    position: fixed;
    top: 50%;
    left: 88px;

    @media (--viewport-laptop) {
        bottom: 30px;
        top: unset;
        left: 50%;
        left: calc(50% - 7px);
    }

    @media (--viewport-tablet) {
        display: none;
        top: unset;
        bottom: 30px;
        left: 50%;
        left: calc(50% - 7px);
    }

    &__icon {
        // cursor: url('../assets/img/ui/sniper-scope-pointer.png') 18 18, pointer;
        width: 30px;
        height: 42px;
        stroke: var(--color-theme);
        stroke-width: 2px;
        fill: none;

        @media (--viewport-laptop) {
            width: 15px;
            height: 21px;
        }

        @media (--viewport-tablet) {
            width: 15px;
            height: 21px;
        }

        &.active {
            fill: var(--color-theme);
        }
    }
}
</style>
